import { type AxiosInstance } from 'axios'

export default (axios: AxiosInstance) => ({
  list(params?: ListUsersQueryParams) {
    return axios.get<PaginatedResponse<OptionItem>>('/v1/get-all-users/', { params })
  },
})
